import React, { useState } from 'react'

import {
  TableContainerStyled,
  TableBodyStyled,
  TableCellStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Row
} from 'components'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import moment from 'moment'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { IGetWithFiltersResponse } from 'services/GST/Parameterization'
import { ViewFileIcon } from 'components/Icons'
import { useModal, useToggle } from 'hooks'
import ViewEmailBody from 'components/ViewEmailBody/ViewEmailBody'

// import { Container } from './styles';
interface ITableJobs {
  tableData: IPaginatedEntityGST<IGetWithFiltersResponse[]>
  page: number
  rowsPerPage: number
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
  handleChangePage: IHandleChangePage
}
const TableConsultaJobs: React.FC<ITableJobs> = ({
  tableData,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage
}) => {


  const [emailBodyJobSelected, setEmailBodyJobSelected] = useState<any>();
  const [openEmailBodyModal, toggleEmailBodyModal] = useToggle()
  const { showModal } = useModal()

  const showEmailJobModal = (txCorpoEmail: string) => {

    if (txCorpoEmail === null || txCorpoEmail === undefined) {
      showModal({
        hideButtonCancel: true,
        message: 'Não é possivel visualizar o corpo do email.',
        type: 'alert',
        txtButtonConfirm: 'Fechar'
      })
      return
    }

    setEmailBodyJobSelected(txCorpoEmail)
    toggleEmailBodyModal()
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled>Fornecedor</TableCellStyled>
              <TableCellStyled>E-mail Fornecedor</TableCellStyled>
              <TableCellStyled align="center">Data Envio</TableCellStyled>
              <TableCellStyled>Matrícula</TableCellStyled>
              <TableCellStyled>Nome Contraparte</TableCellStyled>
              <TableCellStyled align="center">Tipo</TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.entity?.items.map((row) => (
              <TableRowStyled key={row?.idLogEmailJob}>
                <TableCellStyled>{row?.cdContrato}</TableCellStyled>
                <TableCellStyled>{row?.nmFornecedor}</TableCellStyled>
                <TableCellStyled>{row?.txEmailResponsavel}</TableCellStyled>
                <TableCellStyled align="center">
                  {moment(row?.dtEnvioEmail).format('DD/MM/YYYY')}
                </TableCellStyled>
                <TableCellStyled>{row?.cdMatriculaContraparte}</TableCellStyled>
                <TableCellStyled>{row?.nmContraparte}</TableCellStyled>
                <TableCellStyled align="center">
                  {row?.nmTipoJOB}
                </TableCellStyled>
                <TableCellStyled align="center">
                  <Row justifyContent="center" alignItems="center">
                    <ViewFileIcon
                      cursor="pointer"
                      onClick={() => showEmailJobModal(row?.txCorpoEmail)}
                    />
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData?.entity?.items}
        totalItems={tableData?.entity?.pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <ViewEmailBody
        showModal={openEmailBodyModal}
        emailBody={emailBodyJobSelected}
        toggleModal={toggleEmailBodyModal}
      />
    </>
  )
}

export default TableConsultaJobs